import { useEffect, useState } from 'react';
import { t } from '../i18n/idioma';
import { useIdioma } from '../i18n/useIdioma';
import { aoSincronizarHora, formatarHora, minutoAgora, msPorMinutoAtual } from '../world/relogio';

/**
 * A hora de Britannia, discreta no radar (techspec-dia-e-noite §05): "18:40" em português, "6:40 PM" nos outros
 * idiomas. Anda um minuto de Britannia por vez (5 s reais) e pula na hora quando o servidor manda outra.
 */
export function HoraDoMundo() {
  const idioma = useIdioma();
  const [minuto, setMinuto] = useState(() => Math.floor(minutoAgora()));

  useEffect(() => {
    let timer = 0;
    const tick = () => {
      setMinuto(Math.floor(minutoAgora()));
      const agora = minutoAgora();
      const falta = (Math.floor(agora) + 1 - agora) * msPorMinutoAtual();
      timer = window.setTimeout(tick, Math.max(250, falta + 20));
    };
    tick();
    const sair = aoSincronizarHora(() => { window.clearTimeout(timer); tick(); });
    return () => { window.clearTimeout(timer); sair(); };
  }, []);

  const texto = formatarHora(minuto, idioma);
  return (
    <span className="coord__hora" title={t('mundo.horaBritannia')} aria-label={`${t('mundo.horaBritannia')}: ${texto}`}>
      {texto}
    </span>
  );
}
